import { Component } from 'react'
import { TrackJS } from 'trackjs'

TrackJS.install({
  token: process.env.REACT_APP_TRACKJS_TOKEN || 'local',
  application: process.env.REACT_APP_TRACKJS_APP || 'local',
})

export class ErrorBoundary extends Component {
  componentDidCatch(error: any, errorInfo: any) {
    if (errorInfo && errorInfo.componentStack) {
      // It's fine to keep console log since this is an internal tool
      console.log(errorInfo.componentStack)
    }

    TrackJS.track(error)
    this.setState({ error })
  }
  render() {
    return this.props.children
  }
}
